<div class="div-add-search">
    <div class="search-wrap section">
            <button class="add-btn-user" [disabled]="buttonDisabled" [ngClass]="{ addbtnuserClient: isClientUsers }"
                (click)="showModal(content, null, 0)" data-testid="userlist-add-user-button">
                <i class="fa fa-plus-circle"></i> Add user
            </button>
        <span>
            <button class="globlesearchicon" data-testid="userlist-serach-button" (click)="activeSearch()" placement="left" ngbTooltip="Show/Hide filter"  tooltipClass="ngTooltip">
                <i class="fa fa-search"></i>
            </button>
            <div class="search-box" [ngClass]="[isActiveSearch ? 'showSeachBox' : 'hideSeachBox']">
                <div class="row">
                    <div class="col-md-2 col-sm-4 col-6 right">
                        <input type="search" autocomplete="off" data-testid="userlist-search-input" (keyup)="removeFilter($event)"  [(ngModel)]="listingBodyParameter.stSearchText" name="gsearch"
                            class="search client-uni" placeholder="search" (keyup.enter)="searchData()"
                            (keyup.enter)="searchData()" />
                    </div>
                </div>
            </div>
        </span>
    </div>

</div>
<div class="table-responsive">
    <table class="user-list-table" data-testid="userlist-table">
        <thead>
            <tr>
                <th style="width: 15%;">
                    <button class="sort-by users-headers" data-testid="userlist-name-button" >
                        Name
                        <span><i class="fa fa-angle-up" [ngClass]="{ sortActiveclass: upName }" (click)="
                                                                sort('stName', 'asc'); makeActiveInactive('stName', 'asc')
                                                              " aria-hidden="true" >
                            </i>
                            <i class="fa fa-angle-down" [ngClass]="{ sortActiveclass: downName }" (click)="
                                                                sort('stName', 'desc');
                                                                makeActiveInactive('stName', 'desc')
                                                              " aria-hidden="true" >
                            </i>
                        </span>
                    </button>
                </th>
                <th style="width: 15%;">
                    <button class="sort-by users-headers" data-testid="userlist-role-button" >
                        Role
                        <span><i class="fa fa-angle-up" [ngClass]="{ sortActiveclass: upUserType }"  
                            (click)="sort('name', 'asc'); makeActiveInactive('name', 'asc')" 
                                aria-hidden="true"></i>
                                <i class="fa fa-angle-down"
                                [ngClass]="{ sortActiveclass: downUserType }"  (click)="
                                                                sort('name', 'desc');
                                                                makeActiveInactive('name', 'desc')
                                                              " aria-hidden="true"></i></span>
                    </button>
                </th>
                <th style="width: 2%;">
                    <button class="sort-by users-headers" data-testid="userlist-request-button">
                        # Requests
                      </button>
                </th>
                <th style="width: 22%;">
                    <button class="sort-by users-headers" data-testid="userlist-email-button" >
                        Email
                        <span><i class="fa fa-angle-up" [ngClass]="{ sortActiveclass: upEmail }" (click)="
                                        sort('Email', 'asc'); makeActiveInactive('Email', 'asc')
                                      " aria-hidden="true"></i><i class="fa fa-angle-down"
                                [ngClass]="{ sortActiveclass: downEmail }" (click)="
                                        sort('Email', 'desc');
                                        makeActiveInactive('Email', 'desc')
                                      " aria-hidden="true"></i></span>
                    </button>
                </th>

                <th style="width: 13%;">
                    <button class="sort-by users-headers" data-testid="userlist-contact-button" >
                        Contact
                        <span><i class="fa fa-angle-up"  [ngClass]="{ sortActiveclass: upContact }" (click)="
                                        sort('PhoneNumber', 'asc'); makeActiveInactive('PhoneNumber', 'asc')
                                      " aria-hidden="true"></i><i class="fa fa-angle-down"
                                [ngClass]="{ sortActiveclass: downContact }"  (click)="
                                        sort('PhoneNumber', 'desc');
                                        makeActiveInactive('PhoneNumber', 'desc')
                                      " aria-hidden="true"></i></span>
                    </button>
                </th>
                <th style="width: 17%;">
                    <button class="sort-by users-headers" data-testid="userlist-last-seen-button">
                        Last seen
                        <span><i class="fa fa-angle-up" [ngClass]="{ sortActiveclass: upLastSeen }" (click)="sort('LastSeen', 'asc');
                              makeActiveInactive('LastSeen', 'asc')
                            " aria-hidden="true" ></i><i class="fa fa-angle-down"
                            [ngClass]="{ sortActiveclass: downLastSeen }" (click)="
                              sort('LastSeen', 'desc');
                              makeActiveInactive('LastSeen', 'desc')
                            " aria-hidden="true"></i></span>
                      </button>
                  </th>
                <th style="width: 6%;">
                    <button class="sort-by users-headers" data-testid="userlist-status-button" >
                        Allow login
                        <span><i class="fa fa-angle-up"  [ngClass]="{ sortActiveclass: upStatus }" (click)="
                                        sort('Status', 'asc'); makeActiveInactive('Status', 'asc')
                                      " aria-hidden="true"></i><i class="fa fa-angle-down"
                                [ngClass]="{ sortActiveclass: downStatus }" (click)="
                                        sort('Status', 'desc');
                                        makeActiveInactive('Status', 'desc')
                                      " aria-hidden="true"></i></span>
                    </button>
                </th>
                <th style="width: 10%;">Actions</th>
            </tr>
        </thead>
        <tbody *ngIf="totalUsers > 0; else NodataElseBlock">
            <ng-container *ngFor="
        let user of getModulesResponse
          | paginate
            : {
                id: 'pagination1',
                itemsPerPage: listingBodyParameter.inLimit,
                currentPage: listingBodyParameter.inOffset + 1,
                totalItems: totalUsers
              }; let i = index">
                <tr class="user-row" (mouseleave)="setClickedRow(-1,isHover)">
                    <td>{{user.stName}}</td>
                    <td>{{user.userType}}</td>
                    <td>{{user.requestsCount}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.contact}}</td>
                     <td [style.padding-left]="'4% !important'" *ngIf="!user.lastSeen">-</td>
                    <td *ngIf="user.lastSeen">{{ user.lastSeen | date:'LLL d, y hh:mm a' }}</td>
                    <td *ngIf="user.status == 'Active'"><span class="isActiveGreen fontdesign">{{user.status}}</span></td>
                    <td *ngIf="user.status == 'Inactive'"><span class="inActiveRed fontdesign">{{ user.status }}</span></td>
                    <td *ngIf="user.status == 'Pendingapproval'"><span [ngStyle]="isClientActive == 'Pendingapproval' ? {'cursor': 'text'} : {'cursor': 'pointer'}" (click)="showApprovalModal(userApprovalContent, user);" class="pendingApprovalYellow fontdesign">Pending approval</span></td>
                    <td class="actions-cell" style="position: relative;" *ngIf="user.userId != loCurrentUserData.userId else noaction">
                        <button class="actions-btn" (mouseenter)="setClickedRow(i,isHover)" data-testid="userlist-action-button"
                            [class.activeheader]="i == selectedRow">
                            <span></span><span></span><span></span>
                        </button>
                        <div class="actions-all-btn">
                            <!-- Security hotfix HF-03 (FE-5): only a Super Admin may edit a Super Admin -->
                            <button *ngIf="loCurrentUserData.isSuperAdmin || user.userType != 'Super Admin'" class="btn-wrap small" data-testid="userlist-edit-button" [disabled]="buttonDisabled || user.status == 'Pendingapproval'" (click)="onUpdateUser(content,user.userId,user.status,1)">
                                Edit
                            </button>
                            <button *ngIf="user.status == 'Pendingapproval'" class="btn-wrap small" data-testid="userlist-approve-button" (keypress)="$event.preventDefault();" (click)="updateUserStatus(null, user.userId, 1)">
                                Approve
                            </button>
                            <button *ngIf="user.status == 'Pendingapproval'" class="btn-wrap red-btn small" data-testid="userlist-reject-button" (keypress)="$event.preventDefault();" (click)="updateUserStatus(null, user.userId, 0)">
                                Decline
                            </button>
                            <button data-testid="userlist-history-btn" *ngIf="this.loCurrentUserData.isSuperAdmin == true || this.loCurrentUserData.IsHistoryAccess == true"  class="btn-wrap small" (click)="getUserHistory(user.userId, user.userType)">
                                History
                            </button>
                            <button class="btn-wrap small" data-testid="userlist-login-history-button" (click)="getUserLoginHistory(user.userId)">
                                Login History
                            </button>
                            <button *ngIf="user.isAccountLock == 1" data-testid="userlist-unlock-button" class="btn-wrap small" (click)="unLockUserAccount(user.userId)">
                                Unlock
                            </button>
                            <!-- Security hotfix HF-01.1 (FE-2): LoginWith is accepted only from a Super Admin's own session -->
                            <button *ngIf="loCurrentUserData?.isSuperAdmin == true" class="btn-wrap small" data-testid="userlist-login-with-button" [attr.disabled]="buttonDisabled || user.status == 'Pendingapproval' || isClientExpired == true || user.userType == 'API User' ? '' : null" (click)="loginWith(user.userId)"
                                [ngClass]="{ expiredClient : user.userType == 'API User' ? true : isClientExpired   }">
                                Login With
                            </button>
                            <button *ngIf="loCurrentUserData.isSuperAdmin" data-testid="userlist-2fa-button" class="btn-wrap small" (click)="getRevoke2FA(user.userId)">
                              Revoke 2FA
                          </button>
                            <button class="btn-wrap red-btn small" data-testid="userlist-archive-button1"
                                (click)="showArchiveAlert(contentArchive,user.userId)">
                                Archive
                            </button>
                        </div>
                        <button class="wdth-auto center-down-btn" (click)="setClickedRowForArrow(i)"
                            [class.arrow-active]="i == selectedRowForArrow" data-toggle="collapse" data-testid="userlist-button"
                            [attr.data-target]="'#collapse-' + i" [attr.aria-expanded]="false"
                            [attr.aria-controls]="'collapse-' + i">
                            <i class="fa fa-angle-down" [class.arrow-active]="i == selectedRowForArrow"
                            ></i>
                        </button>
                    </td>
                    <ng-template #noaction>
                        <td></td>
                    </ng-template>
                </tr>

                <tr class="user-detail-box brd-none">
                    <td colspan="8" class="collapse-row ">
                        <div [attr.id]="'collapse-' + i" class="collapse out"
                            [class.row-expand]="i == selectedRowForArrow"
                            [class.row-collapse]="i != selectedRowForArrow">
                            <div class="user-contact-box">
                                <div class="message-box box teaminline">
                                    <h6>Team</h6>
                                    <div *ngIf="user.team == ''; else NABlock">
                                        <p>N/A</p>
                                    </div>
                                    <ng-template #NABlock>
                                        <p>{{user.team}}</p>
                                    </ng-template>
                                </div>
                                <div class="email-box box ">
                                    <h6 class="mrg-lft-minus-6">Created on</h6>
                                    <p class="mrg-lft-minus-6">{{user.createdOn | date:"hh:mm a  LLL d, y"}}</p>
                                </div>

                                <div class="access-token-box box">
                                    <div *ngIf="user.apiAccessToken == null || user.userType == 'Client Admin' || user.userType == 'User' || user.userType == 'Super Admin'; else NotExistBlock">


                                            </div>
                                            <ng-template #NotExistBlock>
                                                <h6 class="mrg-btm-0">API access token</h6>
                                                <p class="access-token-value">{{user.apiAccessToken}}</p>&nbsp;
                                                <button type="button" data-testid="userlist-copy-token-button" class="access-tokon-buttons mr-1 copy-token" (click)="copyToken(user.apiAccessToken)">
                                                    <span aria-hidden="true">
                                                        <a href="javascript:void(0)">
                                                            <i class="fa fa-clipboard fa-lg" placement="top" ngbTooltip="Copy Token"  tooltipClass="ngTooltip"></i>
                                                           </a>
                                                    </span>
                                                </button> &nbsp;
                                                <button type="button" data-testid="userlist-generate-token-button" class="access-tokon-buttons" (click)="generateToken(user.userId)">
                                                    <span aria-hidden="true">
                                                        <a href="javascript:void(0)">
                                                            <i class="fa fa-refresh fa-lg" placement="right" ngbTooltip="Generate New Token"  tooltipClass="ngTooltip"></i>
                                                            </a>
                                                    </span>
                                                </button>
                                        </ng-template>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

            </ng-container>
        </tbody>
        <ng-template #NodataElseBlock>
            <tbody>
                <tr>
                    <td colspan="8">
                        <p class="text-center">{{loadingDataMessage}}</p>
                    </td>
                </tr>
            </tbody>
        </ng-template>
    </table>
</div>
<div [ngClass]="'pag-view'" *ngIf="totalUsers > 0">
    <select class="pager" #prPage (change)="changePageLimit(prPage.value)" data-testid="userlist-page-select">
        <option *ngFor="let pgarr of perPageArray" [value]="pgarr.val"
            [selected]="pgarr.val == listingBodyParameter.inLimit">{{ pgarr.text }}
        </option>
    </select>
    <span class="pager-title">Items per page </span>

    <pagination-controls id="pagination1" (pageChange)="pageChanged($event)">
    </pagination-controls>
    <div class="col-sm-8"></div>
</div>


<!-- Modal - Add/Edit User Starts -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Add/Edit user</h5>
        <button type="button" class="close close-icon" aria-label="Close" data-testid="userlist-close-button" (click)="modal.dismiss('Cross click')">
            <span><img src="../../../../../assets/images/close.svg" /></span>
        </button>
    </div>
    <div class="modal-body mdl-bg-clr">
        <app-adduser [userId]="userId" [roles]="roles" [getUserRole]="getUserRole" [teams]="teams" [isWebPageToggleEnabled]="isWebPageToggleEnabled" (webPageToggle)="onWebPageToggle($event)"></app-adduser>
    </div>
</ng-template>

<!-- Modal - Archive Starts -->
<ng-template #contentArchive let-modal>
    <div class="modal-header">
        <h6 class="modal-title text-center archive-header-title" id="modal-basic-title">Alert</h6>
        <button type="button" class="close close-icon" aria-label="Close" (click)="modal.dismiss('Cross click')" data-testid="userlist-archive-cancel-button">
            <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
        </button>
    </div>
    <div class="modal-body text-center">
        <span class="archive-content"> Are you sure you want to archive this user? </span>
        <button type="button" class="btn-wrap btn-box red-btn archive-btn" data-testid="userlist-archive-button"
            (click)="archive(uId)">Archive</button>
    </div>

</ng-template>
<!-- Modal - Archive Ends -->

<ng-template #userApprovalContent let-modal>
    <div class="modal-header" >
        <h5 class="modal-title">Approve user</h5>
        <button type="button" class="close close-icon" aria-label="Close" (click)="modal.dismiss('Cross click')" data-testid="userlist-approve-close-button">
            <span aria-hidden="true"><img src="../../../../../assets/images/close.svg" /></span>
        </button>
    </div>
    <div class="modal-body user-approval-body">
        <div class="table-box section">
            <div class="user-approval-box">
                <div class="row">
                    <div class="col-md-7 col-sm-12 col-12">
                        <div class="box">
                            <label>Name</label>
                            <p>{{userName}}</p>
                        </div>
                        <div class="box">
                            <label>Email</label>
                            <p>{{userEmail}}</p>
                        </div>
                    </div>
                    <div class="col-md-5 col-sm-12 col-12">
                        <div class="box">
                            <label>Role</label>
                            <p>{{userRole}}</p>
                        </div>
                        <div class="box">
                            <label>Contact</label>
                            <p>{{userContact}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn-wrap red-btn CancelBox" data-testid="userlist-reject-button" (keypress)="$event.preventDefault();" (click)="updateUserStatus(null, userId, 0)">
            Decline
        </button>
        <button type="button" class="btn-wrap btn-box" data-testid="userlist-approve-button" (keypress)="$event.preventDefault();" (click)="updateUserStatus(null, userId, 1)">
            Approve
        </button>
    </div>
</ng-template>
